import axios from 'axios';
import environment from 'environment';

import { JsonResponse } from 'core/models/response';
import { Admin } from 'modules/admins/models/Admin';

export const getProfile = () => {
	return axios.get<JsonResponse<Admin>>(`${environment.BASE_API_ENDPOINT}/admin/show-profile`);
};
